import React, { useState } from 'react';
import { Menu, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import DesktopSidebar from './DesktopSidebar';
import MobileSidebar from './MobileSidebar';
import TopNav from './TopNav';
import { useAuth } from '../contexts/AuthContext';
import { Button } from "@/components/ui/button";

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Desktop Sidebar */}
      <DesktopSidebar />
      
      {/* Mobile Sidebar */}
      <MobileSidebar 
        isOpen={isMobileSidebarOpen} 
        onClose={() => setIsMobileSidebarOpen(false)} 
      />
      
      {/* Top Navigation for desktop */}
      <TopNav />
      
      {/* Main Content */}
      <div className="flex-1 md:ml-64">
        {/* Mobile Header */}
        <header className="md:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-gray-200 h-14 flex items-center justify-between px-4">
          <div className="flex items-center">
            <button 
              onClick={toggleMobileSidebar}
              className="mr-4 p-1"
            >
              <Menu className="h-6 w-6" />
            </button>
            <div className="text-xl font-bold">WANTTD</div>
          </div>
          
          {/* Mobile login/profile button */}
          <div>
            {isAuthenticated ? (
              <Link to="/profile" className="p-2">
                <User className="h-5 w-5" />
              </Link>
            ) : (
              <Link to="/signin">
                <Button size="sm" variant="outline" className="text-xs border-black text-black">
                  Sign in
                </Button>
              </Link>
            )}
          </div>
        </header>
        
        {/* Content Area */}
        <main className="pt-14 md:pt-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppLayout; 